import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve a picture URL coming from the user object:
 * - External (https://) → return as-is (Google profile pic)
 * - /api/uploads/... → prepend backend URL
 * - /uploads/... (legacy) → rewrite to /api/uploads/...
 * - null/undefined → return null
 */
export const resolvePictureUrl = (picture) => {
  if (!picture) return null;
  if (/^https?:\/\//i.test(picture)) return picture;
  const path = picture.startsWith("/api/")
    ? picture
    : picture.replace(/^\/uploads\//, "/api/uploads/");
  return `${BACKEND_URL}${path}`;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add Bearer token fallback for environments where cookies are restricted
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
